module.exports = __webpack_public_path__ + "static/media/css3.c64430b2.svg";